const URI = Object.freeze(
  "https://rfavi3q47a.execute-api.eu-west-1.amazonaws.com/dev/v1"
);
export const APIURI = URI;

export const endPoints = Object.freeze({
  auth: {
    signup: URI + "/auth/signup-email",
    addContact: URI + "/auth/contact",
  }
});
